<div class="tlh-rebalance-settings">
  <div style="border-bottom: 1px solid #C8C8C8;">
    <p-checkbox binary="true" [(ngModel)]="isApplyGlobalTLH"
      [disabled]="(!globalSettings.isTlhLotLevel && !globalSettings.isTlhPositionLevel) || isReadOnly"
    (onChange)="onApplyGlobalchange($event)" inputId="tlhrebsecitem1"></p-checkbox>
    <label for="tlhrebsecitem1" style="margin-left: .4rem;">Apply global and model settings for tax loss harvesting</label>
    <div style="padding: 10px 0;">
      Tax loss harvest settings can be configured from iRebal settings. <a (click)="openRebalanceGlobalSettings()">Go to Settings</a>
    </div>
  </div>


  @if (isApplyGlobalTLH) {
    <div style="padding: 10px 0;">
      <div class="flex-row">
        <div class="flex-column-header">
          Loss detection level
          <span class="tooltipIconLeft infoIcon" calltoaction
            [calltoactionTemplate]="harvestSecuritySettingsLDLInfoToolTipIcon">
          </span>
        </div>
        <div class="flex-column">
          <p-radioButton name="harvest-lot-level"
            [value]="true"
            disabled="true"
            [ngModel]="isGlobalTlhLotLevel"
            inputId="lotRadio"
          ></p-radioButton>
          <label for="lotRadio">Lot level</label>
          <p-radioButton name="harvest-lot-level"
            [value]="true"
            disabled="true"
            [ngModel]="isGlobalTlhPositionLevel"
            inputId="positionRadio"
          ></p-radioButton>
          <label for="positionRadio">Position level</label>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column-header">
          <div class="block"><strong>Minimum Loss Threshold</strong></div>
        </div>
        <div class="flex-column">
          <div class="block"><strong>Min %</strong> <span style="padding-left: 10px;">{{globalSettings.tlhMinPerc}}%</span></div>
          <div><strong>Min $</strong> <span style="padding-left: 13px;">${{globalSettings.tlhMinDollarAmnt | number}}</span></div>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column-header">Securities</div>
        <div class="flex-column">
          Securities must be enabled individually for harvesting. Adjust settings on the securities page.
          <a style="padding-left:10px;" (click)="goToSecurities()">Go to Securities</a>
        </div>
      </div>
    </div>
  }



  @if (!isApplyGlobalTLH) {
    <div  style="padding: 10px 0;">
      <div class="flex-row">
        <div class="flex-column-header">
          Harvest tax losses the same way as
          <span class="tooltipIconLeft infoIcon" calltoaction
            [calltoactionTemplate]="harvestTaxLossSameWayInfoToolTipIcon">
          </span>
        </div>
        <div class="flex-column">
          <irb-dropdown-filter #harvestedSecuritiesSameWayAsDropdown
            id="irbSelectedRebalanceTypeDropdown"
            placeholder="Select Tax Loss Harvest To Clone"
            [disabled]="isReadOnly"
            size="40"
            hoverPanelWidth="320"
            (search)="setSameTLHOptions($event)"
            (selection)="onHtlChange($event)"
          ></irb-dropdown-filter>
          <button class="btn-medium-secondary btn-spacer" [disabled]="isReadOnlyClear" (click)="onClearTaxLossToClone()">Clear</button>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column-header">
          Loss detection level
          <span class="tooltipIconLeft infoIcon" calltoaction
            [calltoactionTemplate]="harvestSecuritySettingsLDLInfoToolTipIcon">
          </span>
        </div>
        <div class="flex-column">
          <p-radioButton name="harvest-lot-level"
            [value]="true"
            [(ngModel)]="data.harvestTaxLossDto.isLotLevel"
          (onClick)="emitChange()" inputId="tlhrebsecitem2"></p-radioButton>
          <label for="tlhrebsecitem2">Lot level</label>
          <p-radioButton name="harvest-lot-level"
            [value]="false"
            [(ngModel)]="data.harvestTaxLossDto.isLotLevel"
          (onClick)="emitChange()" inputId="tlhrebsecitem3"></p-radioButton>
          <label for="tlhrebsecitem3">Position level</label>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column-header">
          Securities to be harvested
        </div>
        <div class="flex-column">
          <div class="flex-securities-search-container block">
            <div class="search-add-container">
              <div class="search-symbol-header">Search by symbol</div>
              <div>
                <irb-dropdown-search-multiple #harvestedSecuritiesDropdown
                                                          style="margin-left: 10px;
                                                          vertical-align: bottom;
                                                          margin-bottom: -2px;
                                                          display: inline-block;"
                  size="30"
                  [addNewItem]="addNewSecurityItem"
                  (openNewItemFlow)="openNewItemSecurityFlow($event, false)"
                  (search)="filterSecurities($event)"
                  [enableHiddenSearchResults]="true"
                  (selection)="captureAddSecurity($event)">
                </irb-dropdown-search-multiple>
              </div>
              <div>
                <button class="btn-medium-secondary securities-to-be-harvested btn-spacer" [disabled]="isReadOnly" (click)="addSecurity()">
                  Add
                </button>
              </div>
            </div>
            <div class="search-add-container">
              <div class="search-symbol-header"> Search by attributes</div>
              <div>
                <button id="advancedFilterButton" (click)="showAddMultipleSecuritiesDialog()" [disabled]="isReadOnly"
                  class="btn-medium-secondary replace-securiries-btn-add-multi">Advanced Filter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="flex-row">
          <div class="flex-column-header"></div>
          <div class="flex-column" style="width: 870px;">
            <div class="schwab-blue-info-card">
              <div class="block">
                Global tax loss harvest thresholds and replacement settings will apply to securities. Override those configurations in harvest securities settings here.
              </div>
              Adjust individual security settings on the securities page.
              <a style="padding-left:10px;" (click)="goToSecurities()">Go to Securities</a>
            </div>
          </div>
        </div>
        <div class="flex-row">
          <div class="flex-column-header">
            Harvest Securities Settings
            <span class="tooltipIconLeft infoIcon" calltoaction
              [calltoactionTemplate]="harvestSecuritySettingsInfoToolTipIcon">
            </span>
          </div>
          <div class="flex-column">
            <div class="block">Specify values to apply to all securities listed below (optional)</div>
            <div class="flex-row">
              <div style="width:270px; border-right: 1px solid #C8C8C8;">
                <div class="flex-column-header block">
                  Minimum Loss Threshold
                  <span class="tooltipIconLeft infoIcon" calltoaction
                    [calltoactionTemplate]="minimumLossThresholdInfoToolTipIcon">
                  </span>
                </div>
                <div class="block" style="display:flex;">
                  <div class="bold" style="width:50px;">Min % </div>
                  <irb-number-text-box [(value)]="percentAmount" [isPercentage]="true" places="2" min="0"  max="100" width="130px"
                    placeholder="Input min %" invalidRangeMessage="Please enter a value between 0..100" [isRequired]="true"
                    [disabled]="isReadOnly" (change)="onPercentChange()">
                  </irb-number-text-box>
                  <a style="margin-left: 10px;" (click)="onPercentApply()">Apply to all</a>
                </div>
                <div class="block" style="display:flex;">
                  <div class="bold" style="width:50px;">Min $ </div>
                  <irb-number-text-box [(value)]="dollarAmount" [isCurrency]="true" places="2" min="0"  width="130px"
                    placeholder="Input min $" [isRequired]="true"
                    [disabled]="isReadOnly" (change)="onDollarChange()">
                  </irb-number-text-box>
                  <a style="margin-left: 10px;" (click)="onDollarApply()">Apply to all</a>
                </div>
              </div>
              <div style="padding-left:15px;">
                <div class="flex-column-header block">Replace with
                  <span class="tooltipIconLeft infoIcon" calltoaction
                    [calltoactionTemplate]="replaceWithInfoToolTipIcon">
                  </span>
                </div>
                <div class="block" style="display:flex;">
                  <div class="bold" style="width:80px;">Primary </div>
                  <irb-dropdown-search
                    #primarySecuritiesDropdownDropdown
                    [addNewItem]="addNewSecurityItem"
                    (openNewItemFlow)="openNewItemSecurityFlowForReplace($event, true)"
                    [(value)]="selectedPrimarySecurity"
                    (search)="getPrimarySecuritiesDropdown($event)"
                    (selection)="onPrimarySecurityChanged($event)"
                    (clearSelection)="onClearSelection('primary')"
                    placeholder="Search for symbol"
                    size="20" hoverPanelWidth="195">
                  </irb-dropdown-search>
                  <a style="margin-left: 10px;" (click)="onPrimarySecurityApply()">Apply to all</a>
                </div>
                <div class="block" style="display:flex;">
                  <div class="bold" style="width:80px;">Secondary </div>
                  <irb-dropdown-search
                    #secondarySecuritiesDropdownDropdown
                    [addNewItem]="addNewSecurityItem"
                    (openNewItemFlow)="openNewItemSecurityFlowForReplace($event, false)"
                    [(value)]="selectedSecondarySecurity"
                    (search)="getSecondarySecuritiesDropdown($event)"
                    (selection)="onSecondarySecurityChanged($event)"
                    (clearSelection)="onClearSelection('secondary')"
                    placeholder="Search for symbol"
                    size="20" hoverPanelWidth="195">
                  </irb-dropdown-search>
                  <a style="margin-left: 10px;" (click)="onSecondarySecurityApply()">Apply to all</a>
                </div>
              </div>
            </div>
            <div>
              <strong>{{rowCount}} securities to harvest</strong>
              <a style="float: right;" class="tlh-rebalance-export-securities-link" [class]=" !rowCount? 'disabled' : ''"
                (click)="exportToExcel()" >Export Securities
                <fa-icon id="exportLink" [icon]="faDownload" class="clickable" tooltip [tooltipTitle]="'Export'"></fa-icon>
              </a>
            </div>
            <div style="clear:both;">
              @if (!isUiTest && cashSecurity) {
                <irb-inventory-grid
                  [style.width]="'870px'"
                  [style.height]="'240px'"
                  [gridHeight]="'240px'"
                  [showSideBar]="false"
                  [gridOptions]="gridOptions"
                  [frameworkComponents]="frameworkComponents"
                (gridReady)="onGridReady($event)"></irb-inventory-grid>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <ng-template #harvestTaxLossSameWayInfoToolTipIcon>
    You can select from one of your previous 5 tax harvests to have iRebal copy the list of harvest securities and their settings into this tax harvest, so you don't have to enter these settings again. You can edit the settings after copying them from a previous tax harvest.
  </ng-template>
  <ng-template #harvestSecuritySettingsInfoToolTipIcon>
    After selecting securities to harvest, you can use these to quickly apply the same min loss % or amount thresholds, and/or replacement securities for all harvest securities, so you don't have to enter the same settings for each security. You can edit the settings for any individual security after applying these same settings to all.
  </ng-template>
  <ng-template #harvestSecuritySettingsLDLInfoToolTipIcon>
    Select Position level if you only wish to harvest when an entire holding in an account can be sold while meeting your thresholds. <br>
    <br>
      Select Lot level if you are willing to sell partial holdings as part of tax loss harvesting.
    </ng-template>
    <ng-template #minimumLossThresholdInfoToolTipIcon>
      iRebal will evaluate holdings in taxable accounts for each security that you list here. iRebal will first look at the % loss, either at the lot or position level based on your loss detection level setting below, and select only those (lots or positions) that exceed the % threshold you specify. Next, looking only at lots or positions that passed the % threshold check, iRebal will propose a sale only if the $ loss on the total sale of the security in the account will exceed the $ amount threshold you specify.
    </ng-template>
    <ng-template #replaceWithInfoToolTipIcon>
      You can tell iRebal to purchase a security in place of the security being sold, or you can choose to leave the proceeds of the sale in cash. You may select different replacement securities for each harvested security. In order to mitigate wash sale concerns, the security which is purchased to replace a harvested security will be considered as equivalent to the security sold if the portfolio is rebalanced within the next 30 days.
    </ng-template>
